import ApiService from 'utils/ApiCalls';

const fetchBranches = async (data: any) => {
  try {
    const response = await ApiService.getBranches(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const fetchEntityContractualArrangements = async (data: any) => {
  try {
    const response = await ApiService.getEntityContractualArrangements(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const fetchContractualArrangementsLei = async (data: any) => {
  try {
    const response = await ApiService.getContractualArrangementsLei(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const fetchContractualArrangementsICT = async (data: any) => {
  try {
    const response = await ApiService.getContractualArrangementsICT(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const fetchRT0101 = async (data: { entityId: string[]; date?: string }) => {
  try {
    const response = await ApiService.getRT0101(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const fetchRT0102 = async (data: any) => {
  try {
    const response = await ApiService.getRT0102(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
const fetchRT0201 = async (data: any) => {
  try {
    const response = await ApiService.getRT0201(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
const fetchRT0202 = async (data: any) => {
  try {
    const response = await ApiService.getRT0202(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
const fetchRT0302 = async (data: any) => {
  try {
    const response = await ApiService.getRT0302(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
const fetchRT0501 = async (data: any) => {
  try {
    const response = await ApiService.getRT0501(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
const fetchRT0502 = async (data: any) => {
  try {
    const response = await ApiService.getRT0502(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
const fetchRT0601 = async (data: any) => {
  try {
    const response = await ApiService.getRT0601(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
const fetchRT0701 = async (data: any) => {
  try {
    const response = await ApiService.getRT0701(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const fetchAR0101 = async (data: any) => {
  try {
    const response = await ApiService.getAR0101(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const fetchAR0102 = async (data: any) => {
  try {
    const response = await ApiService.getAR0102(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const fetchAR0103 = async (data: any) => {
  try {
    const response = await ApiService.getAR0103(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const fetchReportData = async (data: any) => {
  try {
    const response = await ApiService.getReportData(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const fetchReportFunctions = async (data: any) => {
  try {
    const response = await ApiService.getReportFunctions(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const fetchReportTPPs = async (data: any) => {
  try {
    const response = await ApiService.getReportTPPs(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const fetchCertificatesByICTServices = async (data: any) => {
  try {
    const response = await ApiService.getCertificatesByICTServices(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const fetchCertificatesByFunction = async (data: any) => {
  try {
    const response = await ApiService.getCertificatesByFunction(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const fetchCertificatesByICTSystemFunction = async (data: any) => {
  try {
    const response = await ApiService.getCertificatesByICTSystemsFunction(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const fetchCertificatesByICTSystemICTService = async (data: any) => {
  try {
    const response =
      await ApiService.getCertificatesByICTSystemsICTServices(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const fetchEntitiesByFinancialLei = async (data: any) => {
  try {
    const response = await ApiService.getEntitiesByFinancialLei(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const fetchReportICTServices = async (data: any) => {
  try {
    const response = await ApiService.getReportICTServices(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const fetchReportICTSystems = async (data: any) => {
  try {
    const response = await ApiService.getReportICTSystems(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const fetchB9901 = async (data: any) => {
  try {
    const response = await ApiService.getB9901(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const fetchContractualArrangementsICTUse = async (data: any) => {
  try {
    const response = await ApiService.getContractualArrangementsICTUse(data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const getRolesAndResponsibilities = async (
  entity_id: string | number,
  date: string,
) => {
  try {
    const response = await ApiService.getRolesAndResponsibilities(
      entity_id,
      date,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

const getICTRiskSource = async (entity_id: string | number, date: string) => {
  try {
    const response = await ApiService.getICTRiskSource(entity_id, date);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

const getICTExposure = async (entity_id: string | number, date: string) => {
  try {
    const response = await ApiService.getICTExposure(entity_id, date);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

const getICTRiskExposureFunctionDetails = async (
  entity_id: string | number,
  date: string,
) => {
  try {
    const response = await ApiService.getICTRiskExposureFunctionDetails(
      entity_id,
      date,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

const getICTRiskExposureService = async (
  entity_id: string | number,
  date: string,
) => {
  try {
    const response = await ApiService.getICTRiskExposureService(
      entity_id,
      date,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

const filterEnityToFunctionChain = async (entity_id: any, date: string) => {
  try {
    const response = await ApiService.filterEntityFunctionChain(
      entity_id,
      date,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

const filterEnityToTPPChain = async (entity_id: any, date: string) => {
  try {
    const response = await ApiService.filterEntityTPPChain(entity_id, date);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

const filterEnityToFunctionReverse = async (entity_id: any, date: string) => {
  try {
    const response = await ApiService.filterEntityFunctionReverse(
      entity_id,
      date,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export default {
  fetchEntityContractualArrangements,
  fetchBranches,
  fetchContractualArrangementsLei,
  fetchContractualArrangementsICT,
  fetchContractualArrangementsICTUse,
  fetchRT0101,
  fetchRT0102,
  fetchRT0201,
  fetchRT0202,
  fetchRT0302,
  fetchRT0501,
  fetchRT0502,
  fetchRT0601,
  fetchRT0701,
  fetchAR0101,
  fetchB9901,
  fetchAR0102,
  fetchAR0103,
  fetchReportData,
  fetchReportFunctions,
  fetchReportTPPs,
  fetchReportICTServices,
  fetchReportICTSystems,
  fetchCertificatesByICTServices,
  fetchCertificatesByFunction,
  fetchCertificatesByICTSystemFunction,
  fetchCertificatesByICTSystemICTService,
  fetchEntitiesByFinancialLei,
  getRolesAndResponsibilities,
  getICTRiskSource,
  getICTExposure,
  getICTRiskExposureFunctionDetails,
  getICTRiskExposureService,
  filterEnityToFunctionChain,
  filterEnityToTPPChain,
  filterEnityToFunctionReverse,
};
